import { Component, Input } from '@angular/core';
import { IPrintOptions, IStyleOptions } from '@modeso/types__aumico-lib-annualreport-be';
import Debug from 'debug';

const debug = Debug('aumico:project-reports-fe:AnnualReportCoverPage');

@Component({
    selector: 'aumico-annual-report-signature-page',
    template: `
        <aumico-annual-report-signature-display
            [stylePreferenceOptions]="stylePreferenceOptions"
            [signaturePlaceDate]="signaturePlaceDate"
            [signatures]="signatures"
        >
        </aumico-annual-report-signature-display>
    `,
})
export class AnnualReportSignaturePage {
    signaturePlaceDate: string | undefined;
    signatures: string[];

    private _printOptions: IPrintOptions | undefined;
    @Input()
    public set printOptions(value: IPrintOptions) {
        this._printOptions = value;
        this.extractData(value);
    }

    public get printOptions(): IPrintOptions | undefined {
        return this._printOptions;
    }
    stylePreferenceOptions: IStyleOptions | undefined;

    private extractData(printOptions: IPrintOptions): void {
        this.signaturePlaceDate = [printOptions.signatureOptions.place, printOptions.signatureOptions.date]
            .filter((value) => value != null && value.trim().length !== 0)
            .join(', ');
        const signatures = [printOptions.signatureOptions.signature1];
        if (printOptions.signatureOptions.isCollectiveSignature) {
            signatures.push(printOptions.signatureOptions.signature2);
        }
        this.signatures = signatures;
        this.stylePreferenceOptions = printOptions.styleOptions;
    }
}
